export const LESSON_REQUEST_TYPES = {
    REGULAR: "REGULAR",
    SPECIAL: "SPECIAL",
    PREMIUM: "PREMIUM",
    TRIAL: "TRIAL",
};

export const LESSON_REQUEST_FLOW_ORDER = [
    
    LESSON_REQUEST_TYPES.TRIAL,
    LESSON_REQUEST_TYPES.REGULAR,
    LESSON_REQUEST_TYPES.PREMIUM,
    LESSON_REQUEST_TYPES.SPECIAL,
];

export const LESSON_REQUEST_TYPE_ORDER = LESSON_REQUEST_FLOW_ORDER;

export const LESSON_REQUEST_TYPE_META = {
    REGULAR: {
        emoji: "🎫",
        title: "수업 개설 요청",
        shortTitle: "강습권",
        description: "보유한 수강권으로 원하는 날·원하는 장소에서 수업을 열어요.",
        note: "강사가 수락하면 수강권이 1회 차감되요",
        tags: ["입문·초급 2강", "입문·초급 3강", "중급 2강"],
        accent: "success",
    },
    SPECIAL: {
        emoji: "🎓",
        title: "특강 개설",
        shortTitle: "스페셜 트레이닝",
        description: "이퀄라이징·딥탱크 등 소수로 진행되는 특강을 열어요.",
        note:  "강사가 수락한 후 수강권 1회 차감 · 추가 결제가 진행되요",
        tags: ["이퀄라이징", "딥탱크", "수중촬영", "노핀"],
        accent: "success",
    },
    PREMIUM: {
        emoji: "⭐",
        title: "프리미엄 트레이닝",
        shortTitle: "프리미엄",
        description: "이퀄라이징·딥탱크·수중촬영 등 소수정예 집중 트레이닝을 요청해요.",
        note: "강사가 수락하면 결제가 필요해요",
        tags: ["이퀄라이징", "딥탱크", "수중촬영", "노핀"],
        accent: "success",
    },
    TRIAL: {
        emoji: "🤿",
        title: "체험 다이빙",
        shortTitle: "체험",
        description: "처음이라 부담 없이 원데이클래스로 시작하세요.",
        note: "강사가 스케쥴 확정 하면 결제가 필요해요",
        tags: ["프리다이빙 체험", "스쿠버 체험", "머메이드 체험"],
        accent: "success",
    },
};

export const LESSON_REQUEST_STATUS = {
    ALL: "ALL",
    PENDING: "PENDING",
    CONFIRMED: "CONFIRMED",
    OPENED: "OPENED",
    REJECTED: "REJECTED",
    EXPIRED: "EXPIRED",
    CANCELLED: "CANCELLED",
};

export const LESSON_REQUEST_STATUS_LABEL = {
    ALL: "전체",
    PENDING: "대기",
    CONFIRMED: "확정",
    OPENED: "오픈",
    REJECTED: "거절",
    EXPIRED: "만료",
    CANCELLED: "취소",
};

export const LESSON_REQUEST_STATUS_TONE = {
    PENDING: "blue",
    CONFIRMED: "green",
    OPENED: "purple",
    REJECTED: "red",
    EXPIRED: "black",
    CANCELLED: "red",
};

const buildHalfHourSlots = (startHour, endHour) => {
    const slots = [];
    for (let hour = startHour; hour <= endHour; hour += 1) {
        slots.push(`${String(hour).padStart(2, "0")}:00`);
        if (hour < endHour) slots.push(`${String(hour).padStart(2, "0")}:30`);
    }
    return slots;
};

export const TIME_SLOT_GROUPS = [
    { label: "오전", times: buildHalfHourSlots(7, 22) },
    // { label: "오후", times: buildHalfHourSlots(12, 22) },
];

export const DEFAULT_TIME_SLOTS = TIME_SLOT_GROUPS.flatMap((group) => group.times);

export const DEFAULT_DURATION_MINUTES = 180;
export const TRIAL_DURATION_MINUTES = 120;

// 프리미엄 트레이닝은 FE 에서 가격을 30,000원으로 고정한다(강사 입력 불가).
// BE 서버 강제 검증은 이번 범위 밖. FE 내 소비처(수락 payload·연습반 개설·강습 전환)는
// 모두 이 상수를 단일 출처로 사용한다.
export const PREMIUM_FIXED_PRICE = 30000;

// 프리미엄 트레이닝 부제목(sub_title). BE 최대 12자, 미입력 시 기본 문구를 사용한다.
export const PREMIUM_DEFAULT_SUB_TITLE = "강사 전담 코칭";
export const PREMIUM_SUB_TITLE_MAX_LENGTH = 12;

export const formatPriceKRW = (value) => `${Number(value || 0).toLocaleString("ko-KR")}원`;

export const getDefaultDurationMinutes = (type) =>
    type === LESSON_REQUEST_TYPES.TRIAL ? TRIAL_DURATION_MINUTES : DEFAULT_DURATION_MINUTES;

export const getRequestTypeMeta = (type) =>
    LESSON_REQUEST_TYPE_META[type] || LESSON_REQUEST_TYPE_META.REGULAR;

export const normalizeLessonRequestList = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.results)) return payload.results;
    return [];
};

export const isTicketRequiredType = (type) =>
    type === LESSON_REQUEST_TYPES.REGULAR || type === LESSON_REQUEST_TYPES.SPECIAL;

export const canCancelLessonRequest = (request) => request?.status === LESSON_REQUEST_STATUS.PENDING;

// 수정도 취소와 동일하게 대기중(PENDING)에서만 가능하다.
export const canEditLessonRequest = (request) => request?.status === LESSON_REQUEST_STATUS.PENDING;

// 강사 판별. 앱 전역에서 is_staff(true)를 강사/스태프 기준으로 쓴다.
export const isInstructorUser = (userInfo) => userInfo?.is_staff === true;

export const formatLessonRequestDayOrder = (request) => {
    if (!request?.requested_day_order) return null;
    return request?.requested_is_theory ? `이론 (${request.requested_day_order}강 전 필수)` : `${request.requested_day_order}강`;
};

// 강사가 후보로서 수락/거절할 수 있는 상태인지. 요청이 대기중이고
// 아직 본인 후보 상태가 결정되지 않았을 때만 액션을 노출한다.
export const canInstructorActOnRequest = (request) => {
    if (request?.status !== LESSON_REQUEST_STATUS.PENDING) return false;
    const candidate = request?.my_candidate_status;
    if (!candidate) return true;
    const decided = ["ACCEPTED", "REJECTED", "CONFIRMED"];
    return !decided.includes(String(candidate).toUpperCase());
};

const readIdCandidate = (value) => {
    if (value === undefined || value === null || value === "") return null;
    if (typeof value === "object") {
        const nested = value.id ?? value.pk ?? value.schedule_id ?? value.practice_schedule_id;
        return nested === undefined || nested === null || nested === "" ? null : nested;
    }
    return value;
};

// 강사 코멘트를 방어적으로 추출한다. instructor/teacher/accept 계열을 우선하고,
// BE 레거시 상세 응답의 generic message 는 후순위 fallback 으로만 사용한다.
// student/requester 계열 메시지는 수강생 본인 메시지이므로 강사 메시지로 표시하지 않는다.
export const getInstructorComment = (request) => {
    const candidates = [
        request?.instructor_message,
        request?.instructor_comment,
        request?.instructor_accept_message,
        request?.accept_message,
        request?.accepted_message,
        request?.acceptance_message,
        request?.teacher_comment,
        request?.teacher_message,
        request?.message,
        request?.reject_reason,
        request?.rejection_reason,
    ];
    const found = candidates.find((value) => typeof value === "string" && value.trim().length > 0);
    return found ? found.trim() : null;
};

// 개설된 연습반(practice) 예약 경로. BE 가 내려줄 수 있는 다양한 키를 방어적으로 본다.
export const getOpenedPracticeReservationPath = (request) => {
    if (!request || typeof request !== "object") return null;
    const practiceScheduleId = [
        request.created_practice_schedule_id,
        request.createdPracticeScheduleId,
        request.practice_schedule_id,
        request.practiceScheduleId,
        request.practice_schedule,
        request.practiceSchedule,
        request.opened_practice_schedule_id,
        request.openedPracticeScheduleId,
        request.opened_practice_schedule,
        request.openedPracticeSchedule,
        request.practice,
        request.practice_schedule_info,
    ].map(readIdCandidate).find((value) => value !== null);
    if (practiceScheduleId) return `/reservation/practice/${encodeURIComponent(practiceScheduleId)}`;
    return null;
};

// 개설된 강습(class/session) 예약 경로.
export const getOpenedClassReservationPath = (request) => {
    if (!request || typeof request !== "object") return null;
    const scheduleId = [
        request.created_session_schedule_id,
        request.createdSessionScheduleId,
        request.schedule_id,
        request.scheduleId,
        request.schedule,
        request.opened_schedule_id,
        request.openedScheduleId,
        request.opened_schedule,
        request.openedSchedule,
        request.schedule_info,
        request.lesson_schedule,
    ].map(readIdCandidate).find((value) => value !== null);
    if (scheduleId) return `/reservation/class/${encodeURIComponent(scheduleId)}`;
    return null;
};

// 알림 라우팅 등 단일 경로가 필요한 곳에서 재사용. 기존 동작(연습반 우선)을 유지한다.
export const getOpenedReservationPath = (request) =>
    getOpenedPracticeReservationPath(request) || getOpenedClassReservationPath(request);

// "HH:mm" 시작 시간에 분을 더한 "HH:mm" 을 반환한다. 자정(24:00) 이상이면 23:59 로 클램프.
export const addMinutesToTime = (time, minutes) => {
    const match = /^(\d{1,2}):(\d{2})/.exec(String(time || ""));
    if (!match) return "";
    const total = Number(match[1]) * 60 + Number(match[2]) + Number(minutes || 0);
    if (!Number.isFinite(total)) return "";
    const clamped = Math.min(Math.max(total, 0), 23 * 60 + 59);
    const hh = String(Math.floor(clamped / 60)).padStart(2, "0");
    const mm = String(clamped % 60).padStart(2, "0");
    return `${hh}:${mm}`;
};

// 강사가 시작 시간을 바꾸면 종료 시간을 시작 + 3시간(기본 강습 길이)으로 자동 설정한다.
export const getAutoEndTime = (startTime) => addMinutesToTime(startTime, DEFAULT_DURATION_MINUTES);

// BE has_changes/changed_fields 표시용 필드 한글 라벨. 미지의 키는 원문 그대로 노출한다.
export const CHANGED_FIELD_LABELS = {
    start_time: "시작 시간",
    end_time: "종료 시간",
    date: "날짜",
    requested_date: "날짜",
    capacity: "정원",
    participant_count: "정원",
    location: "장소",
    location_name: "장소",
    price: "가격",
};

export const getChangedFieldLabel = (field) => CHANGED_FIELD_LABELS[field] || String(field ?? "");

// before/after 는 원시값(문자열/숫자)일 때만 표시한다. 객체를 그대로 렌더하면
// "[object Object]" 가 노출되므로 그런 값은 버린다.
const isPrimitiveChangeValue = (value) => typeof value === "string" || typeof value === "number";
const readChangeValue = (value) => (isPrimitiveChangeValue(value) ? value : null);

// BE changed_fields 를 화면 표시용으로 정규화한다.
// 신규 계약: [{ field, label, before, after }] 객체 배열.
// 레거시: 문자열 배열(["start_time", ...]) 또는 { field: {before, after} } 맵도 방어적으로 지원한다.
const hasChangeDiffValue = (entry) => entry?.before !== null || entry?.after !== null;

// 반환: [{ key, label, before, after }] — 동의어 필드(capacity/participant_count)가 함께 와도
// 같은 라벨은 한 번만 남긴다. 중복 라벨이면 before/after 값이 있는 항목을 우선한다.
export const normalizeChangedFields = (request) => {
    const raw = request?.changed_fields;
    let entries = [];
    if (Array.isArray(raw)) {
        entries = raw.map((item) => {
            if (item && typeof item === "object") {
                const field = readChangeValue(item.field);
                const label = readChangeValue(item.label) || getChangedFieldLabel(field);
                return {
                    key: field ?? label,
                    label,
                    before: readChangeValue(item.before),
                    after: readChangeValue(item.after),
                };
            }
            return { key: item, label: getChangedFieldLabel(item), before: null, after: null };
        });
    } else if (raw && typeof raw === "object") {
        entries = Object.entries(raw).map(([field, value]) => ({
            key: field,
            label: getChangedFieldLabel(field),
            before: value && typeof value === "object" ? readChangeValue(value.before) : null,
            after:
                value && typeof value === "object"
                    ? readChangeValue(value.after)
                    : readChangeValue(value),
        }));
    }

    const byLabel = new Map();
    entries.forEach((entry) => {
        if (!entry.label) return;
        const existing = byLabel.get(entry.label);
        if (!existing || (!hasChangeDiffValue(existing) && hasChangeDiffValue(entry))) {
            byLabel.set(entry.label, entry);
        }
    });
    return Array.from(byLabel.values());
};

export const getLessonRequestAutoTitle = (request) => {
    const candidates = [
        request?.ticket_name,
        request?.ticket?.name,
        request?.user_ticket_name,
        request?.user_ticket?.name,
        request?.lesson_ticket_name,
        request?.lesson_product_name,
        request?.lesson_product_display_name,
        request?.product_name,
        request?.product?.name,
        request?.trial_product_name,
        request?.trial_product?.name,
    ];
    const found = candidates.find((value) => typeof value === "string" && value.trim().length > 0);
    return found ? found.trim() : null;
};


export const LOCATION_TYPES = ["수영장", "잠수풀", "개방수역"];
export const TRIAL_PRODUCTS = ["프리다이빙", "스쿠버다이빙", "머메이드"];
export const TOPIC_CHIPS = ["이퀄라이징", "딥탱크", "수중촬영", "노핀"];